import { render } from "./GastosPlanificados.vue?vue&type=template&id=d8fb27ea&scoped=true"
import script from "./GastosPlanificados.vue?vue&type=script&lang=js"
export * from "./GastosPlanificados.vue?vue&type=script&lang=js"

import "./GastosPlanificados.vue?vue&type=style&index=0&id=d8fb27ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8fb27ea"]])

export default __exports__